import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_layout/campaigns')({
  component: () => <Outlet />,
  loader: () => ({
    crumb: 'Campaigns',
  }),
});
